import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CatalogosService } from '../../../services/catalogos.service';
import { WindowRef } from '../../../services/WindowRef';

@Component({
  selector: 'app-pagar-madamiento',
  templateUrl: './pagar_mandamiento.component.html',
  styleUrls: ['./pagar_mandamiento.component.css'],
  providers: [WindowRef],
})
export class PagarMandamientoComponent implements OnInit {
  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  sw: any;

  scroll: any;
  visibleSpinner: boolean = false;
  searching: boolean = false;
  processing: boolean = false;

  numeroMandamiento: any;
  mandamiento: any = {};
  mostrarDetalles: boolean = Object.keys(this.mandamiento).length > 0;

  errorFlag: boolean = false;
  errorMessage: string;

  successFlag: boolean = false;
  successMessage: string;

  infoFlag: boolean = false;
  infoMessage: string;
  
  windowRef: any;
  notFoundFlag: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private catalogosService: CatalogosService,
    private winRef: WindowRef,
  ) {
    this.windowRef = winRef.nativeWindow;

    if (this.windowRef.addEventListener) {
        this.windowRef.addEventListener('message', this.onMessage, false);
    } else if (this.windowRef.attachEvent) {
      //this.windowRef.attachEvent('onmessage', this.onMessage, false);
    }
  }

  ngOnInit(): void {
    this.errorFlag = false;
    this.successFlag = false;
    this.infoFlag = false;
    this.processing = false;
  }

  scrollHeight(screen): any {
    let set: any;
    if (screen > 1600) {
      set = screen * 0.65;
    } else {
      set = screen * 0.7;
    }
    this.scroll = screen - set;
  }

  filter() {
    this.visibleSpinner = true;
    this.searching = true;

    this.notFoundFlag = false;
    this.errorFlag = false;
    this.successFlag = false;
    this.infoFlag = false;
    this.processing = false;

    this.catalogosService
      .searchMandamiento(this.numeroMandamiento)
      .subscribe((response) => {
        if (response.data.mandamiento) {
          this.mandamiento = response.data.mandamiento;
          this.mostrarDetalles = Object.keys(this.mandamiento).length > 0;
        } else {
          this.errorMessage = response.data.message;
          this.notFoundFlag = true;
          this.mostrarDetalles = false;
        }

        this.visibleSpinner = false;
        this.searching = false;
      });
  }

  onMessage = (event): void => {
    var data = event.data;
    if (typeof this[data.func] == 'function') {
        this[data.func](data.message);
    }
  };

  CallBackPay = (message) => {
    this.successMessage = message;
    this.errorMessage = message;
  };

  CallBackPayJson = (message) => {
    const _data = JSON.parse(message);

    if (_data.SatisFactorio) {
        this.mandamiento.pagado = true;
        this.mandamiento.habilitar_comrpobante = true;

        this.errorFlag = false;
        this.successFlag = true;
        this.infoFlag = false;
        this.processing = false;
    } else {
        this.errorFlag = true;
        this.successFlag = false;
        this.infoFlag = false;
        this.processing = false;

        this.mandamiento.pagado = true;
        setTimeout(() => {
            this.errorFlag = false;
            this.mandamiento.pagado = false;
        }, 7500);
    }
  };

  makePayment = (idMandamiento, total) => {
    this.infoFlag = true;
    this.processing = true;
    this.infoMessage = 'Espera un momento, no cierres esta ventana hasta finalizar con el pago.';
    this.catalogosService
      .getTokenSerfinsa(idMandamiento, total)
      .subscribe((response) => {
          if (response.code === 0) {
              var tituloPop = 'SERFINSA CHECKOUT';
              var urlPost = response.post_url;
              var urlMask = response.mask_url;

              //var top = (screen.height) / 1.5;
              var width = (screen.width - 250) / 2;
              var height = window.screen.height;
              var left = (screen.width - width) / 2;
              var top = (screen.height - height) / 2;
              var params = 'width=' + width + ', height=' + height;
              params += ', top=' + top + ', left=' + left;
              params += ', directories=no';
              params += ', location=no';
              params += ', menubar=no';
              params += ', resizable=no';
              params += ', scrollbars=no';
              params += ', status=no';
              params += ', toolbar=no';
              const windowspop = {
                  url: urlPost,
                  titulo: tituloPop,
                  paramsPopUp: params,
                  urlMask: urlMask,
                  urlData: urlPost,
              };
              this.CallBackPopUp(windowspop);
          } else if (response.code === 6 || response.code === 7) {
              this.errorFlag = true;
              this.infoFlag = false;
              this.successFlag = false;
              this.errorMessage = response.message;
              this.processing = false;

              this.mandamiento.pagado = true;
              setTimeout(() => {
                this.errorFlag = false;
                this.mandamiento.pagado = false;
              }, 7500);
          } else {
              this.errorFlag = true;
              this.successFlag = false;
              this.errorMessage = response.message;

              this.mandamiento.pagado = true;
              setTimeout(() => {
                this.errorFlag = false;
                this.mandamiento.pagado = false;
            }, 7500);
          }
      });
  };

  CallBackPopUp = (datos) => {
      const win = this.windowRef.open(
          datos.url,
          datos.titulo,
          datos.paramsPopUp
      );
      win.focus();
      //win.addEventListener('message', this.onMessage, false);
  };

  verComprobante = (idMandamiento) => {
    this.processing = true;
    this.catalogosService
      .generarComprobanteSerfinsa(idMandamiento)
      .subscribe((response: any) => {
          const blob = new Blob([response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          this.processing = false;
      });
  };
}
